<!-- <lib-site-setup-navbar
  [hasBackButton]="true"
  [stepNumber]="StepNumberEnum.Overview"
  class="w-full"
  [loggedInUser]="vm().currentUser"
></lib-site-setup-navbar> -->
<h1 class="mt-10 text-h1 font-semibold text-text-primary">{{ 'site_install_welcome_title' | translate }}</h1>
<h4 class="mt-2 text-h4 font-light text-text-secondary">{{ 'site_install_welcome_subtitle' | translate }}</h4>

<div class="mt-10 max-w-[1000px]">
  <lib-onboarding-video
    [fileType]="overviewVideo.fileType || ''"
    [videoUrl]="overviewVideo.videoUrl || ''"
    [videoTitle]="overviewVideo.title || ''"
    [thumbnailUrl]="overviewVideo.thumbnailUrl || ''"
    [installationContractId]="vm().contract?.data?.id"
    tutorialModule="site_installation"
  ></lib-onboarding-video>

  <div class="my-10 flex justify-end text-text-primary">
    <div class="flex items-center gap-8">
      <button class="btn-primary-big" (click)="next()">{{ 'site_install_welcome_next_button' | translate }}</button>
    </div>
  </div>
</div>
